module.exports = __webpack_public_path__ + "img/not_found.6b1f3dc7.jpg";